import type { AsyncStatus } from "@react-hookz/web";
import { useEffect, type Dispatch, type SetStateAction } from "react";

import { useInsightFamiliesLoader } from "../../../../hooks/insightFamilies/useInsightFamiliesLoader";
import { isSuccess } from "../../../../utils/api.utils";
import { withInsightsRenderer } from "../withInsightsRenderer";

import { InsightFamilyCardV2 } from "./InsightFamilyCard";

interface InsightFamiliesProps {
    isLoaderInView: boolean;
    setAsyncStatus: Dispatch<SetStateAction<AsyncStatus>>;
    setTotalCount: Dispatch<SetStateAction<number>>;
}

export const InsightFamilies: React.FunctionComponent<InsightFamiliesProps> = ({
    isLoaderInView,
    setAsyncStatus,
    setTotalCount,
}) => {
    const [asyncStatus, lazyLoadedInsights, totalResults] =
        useInsightFamiliesLoader({ isLoaderInView });

    useEffect(() => {
        setAsyncStatus(asyncStatus);
    }, [asyncStatus]);

    useEffect(() => {
        if (isSuccess(asyncStatus)) {
            setTotalCount(totalResults);
        }
    }, [asyncStatus, totalResults]);

    return (
        <>
            {lazyLoadedInsights.map((insight, i) => (
                <InsightFamilyCardV2 insight={insight} key={i} index={i} />
            ))}
        </>
    );
};

export const InsightFamiliesViewer = withInsightsRenderer(InsightFamilies);
